import React, { useMemo } from 'react';
import Checkbox from 'components/ui/CheckBox';

interface IProps {
  label: string;
  note: string;
  changeFunction: (newNote: string) => void;
  entireNote: string;
}

export default function CheckboxNote(props: IProps) {
  const newLine = useMemo(
    () =>
      props.entireNote.replace(props.note, '') !== '' &&
      props.entireNote[props.entireNote.length - 1] !== '\n'
        ? '\n'
        : '',
    [props.entireNote]
  );
  return (
    <Checkbox
      label={props.label}
      checked={props.entireNote?.includes(props.note)}
      onCheckChanged={(checked: any) => {
        if (checked) {
          props.changeFunction(`${props.entireNote || ''}${newLine}${props.note}`);
        } else {
          props.changeFunction(props.entireNote?.replace(`${newLine}${props.note}`, ''));
        }
      }}
    />
  );
}
